import CommonRadioTreeSelect from '../CommonTreeSelect';

import React from 'react';

const PromotionApplied = (props) => {
  const { treeOptions, radioName, selectName, noStyle, disabled } = props;
  return (
    <CommonRadioTreeSelect
      treeOptions={treeOptions}
      radioName={radioName}
      selectName={selectName}
      noStyle={noStyle}
      hasExclude
      disabled={disabled}
    />
  );
};
export default PromotionApplied;
